import { UnitModal } from '@marketertechnologies/property-picker';
import '@marketertechnologies/property-picker/dist/index.min.css';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { getParentHref } from '~/helpers/getParentHref';
import { useRegisterInterest } from '~/hooks/useRegisterInterest';
import { useUTMParams } from '~/hooks/useUTMParams';

import { CallbackArgs, useModal } from './useModal';

const Modal = () => {
  const { uuid: projectUuid } = useParams();

  const [value, setValue] = useState<CallbackArgs>();
  const utmParams = useUTMParams();
  const { mutateAsync: registerInterest } = useRegisterInterest({
    projectUuid,
    searchParams: utmParams,
  });
  const { handleClose } = useModal(setValue);

  useEffect(() => {
    document.body.style.background = 'transparent';
  }, []);

  return value?.unit ? (
    <UnitModal
      {...value}
      projectUuid={projectUuid!}
      key={value.unit.uuid}
      onClose={handleClose}
      onRegisterInterestSubmit={registerInterest}
      parentEndpoint={getParentHref()}
    />
  ) : null;
};

export default Modal;
